import { useCallback, useMemo } from "react";
import { useAppSelector } from "../store";
import {
  CHANNEL_KEYS,
  ChannelFlags,
  ChannelKey,
  canSeeEmailChannel,
} from "../models/company.model";

export const useChannelSettings = () => {
  const rawFlags = useAppSelector((state) => state.company.channels);
  const loaded = useAppSelector((state) => state.company.channelsLoaded);
  const user = useAppSelector((state) => state.auth.user);
  const showEmail = canSeeEmailChannel(user);

  const flags = useMemo(
    () => (showEmail ? rawFlags : { ...rawFlags, email: false }),
    [rawFlags, showEmail]
  );

  const isEnabled = useCallback(
    (key: string) => flags[key as ChannelKey] === true,
    [flags]
  );

  const enabledChannels = useMemo(
    () => CHANNEL_KEYS.filter((key) => flags[key]),
    [flags]
  );

  return { flags, loaded, isEnabled, enabledChannels };
};

export const filterByEnabledChannel = <T extends { key: string }>(
  items: T[],
  flags: ChannelFlags
): T[] => items.filter((item) => flags[item.key as ChannelKey] === true);
